module.exports = __webpack_public_path__ + "59918b2e64c34990abdbd22690714c96.pdf";